module.exports = require('./lib/password-generator');


//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/password-generator/index.js
// module id = 645
// module chunks = 7